import Auth from '@aws-amplify/auth'
import userApi from '@/services/userApi'

export default {
  fetchCurrentAuthenticatedUser: ({ commit }) => {
    return new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          commit('setUser', user)
          resolve(user)
        })
        .catch(reject)
    })
  },
  fetchSession: ({ commit }) =>
    new Promise((resolve, reject) => {
      Auth.currentSession()
        .then((session) => {
          Auth.currentUserPoolUser()
            .then((user) => {
              commit('setUser', user)
              resolve(session)
            })
            .catch(reject)
        })
        .catch(reject)
    }),
  fetchJwtToken: () =>
    new Promise((resolve, reject) => {
      Auth.currentSession()
        .then((session) => {
          resolve(session.getAccessToken().getJwtToken())
        })
        .catch(reject)
    }),
  refreshSession: () =>
    new Promise((resolve, reject) => {
      Auth.currentSession()
        .then((session) => {
          Auth.currentAuthenticatedUser().then((cognitoUser) => {
            cognitoUser.refreshSession(session.refreshToken, (err, session) => {
              resolve(session)
            })
          })
        })
        .catch(reject)
    }),
  signInUser: ({ commit }, credentials) =>
    new Promise((resolve, reject) => {
      Auth.signIn(credentials.username, credentials.password)
        .then((user) => {
          commit('setUser', user)
          resolve(user)
        })
        .catch(reject)
    }),
  answerCustomChallenge: ({ commit }, credentials) =>
    new Promise((resolve, reject) => {
      Auth.sendCustomChallengeAnswer(credentials.user, credentials.answer)
        .then((user) => {
          commit('setUser', user)
          resolve(user)
        })
        .catch(reject)
    }),
  registerUser: ({ commit }, credentials) =>
    new Promise((resolve, reject) => {
      // TODO: Ensure I'm attribute agnostic
      Auth.signUp({
        username: credentials.username,
        password: credentials.password,
        attributes: credentials.attributes,
      })
        .then((user) => {
          commit('setUser', user)
          resolve(user)
        })
        .catch(reject)
    }),
  confirmUser: (_, data) =>
    new Promise((resolve, reject) => {
      Auth.confirmSignUp(data.username, data.code).then(resolve).catch(reject)
    }),
  resendConfirmation: (_, data) =>
    new Promise((resolve, reject) => {
      Auth.resendSignUp(data.username).then(resolve).catch(reject)
    }),
  forgotPassword: (_, data) =>
    new Promise((resolve, reject) => {
      Auth.forgotPassword(data.username).then(resolve).catch(reject)
    }),
  changePasswordWithCode: (_, data) =>
    new Promise((resolve, reject) => {
      Auth.forgotPasswordSubmit(data.username, data.code, data.newPassword)
        .then(resolve)
        .catch(reject)
    }),
  changePassword: (_, data) =>
    new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return Auth.changePassword(user, data.oldPass, data.newPass)
        })
        .then(resolve)
        .catch(reject)
    }),
  updateEmailAddress: async (_, { newEmail, beta }) => {
    return await new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return userApi.changeEmail({
            id: user.attributes.sub,
            email: newEmail,
            beta,
          })
        })
        .then(resolve)
        .catch(reject)
    })
  },
  confirmUpdateEmailAddress: async (_, uuid) => {
    return await new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return userApi.confirmChangeEmail({
            id: user.attributes.sub,
            uuid,
          })
        })
        .then(resolve)
        .catch(reject)
    })
  },
  completePassword: ({ commit }, { newPassword, oldUser }) =>
    new Promise((resolve, reject) => {
      Auth.completeNewPassword(oldUser, newPassword)
        .then((user) => {
          commit('setUser', user)
          resolve(user)
        })
        .catch(reject)
    }),
  forgetSessions: () =>
    //eslint-disable-next-line
    new Promise((resolve, reject) => {
      userApi.logoutSessions().then(resolve).catch(reject)
    }),
  signOut: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.isLoggedIn) {
        reject(new Error('User not logged in.'))
      }

      Auth.signOut()
        .then((result) => {
          commit('setUser', {})
          resolve(result)
        })
        .catch(reject)

      if (localStorage) localStorage.removeItem('USER')
    }),
  getUserDataByID: async () => {
    return await new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
        .then(async (user) => {
          return await userApi.getUserDataByID({
            id: user.attributes.sub,
          })
        })
        .then(resolve)
        .catch(reject)
    })
  },
  updateUserAvatar: async (_, data) => {
    return await new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return userApi.updateUserAvatar({
            id: user.attributes.sub,
            data,
          })
        })
        .then(resolve)
        .catch(reject)
    })
  },
}
